import { render, staticRenderFns } from "./renamed.vue?vue&type=template&id=20fa3da6&"
import script from "./renamed.vue?vue&type=script&lang=js&"
export * from "./renamed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports